"use strict";

define('rs/models/sponsor.category',['rs/models/abstract', 'rs/models/sponsor', 'rs/helper'], function (AbstractModel, SponsorModel, helper) {
  var CategoryModel = AbstractModel.extend({
    properties: ['activityDate', 'updateUserAuthId'],
    serverProperties: ['id', 'description', 'version']
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#sponsor(?*query)': function getSponsorQuery(data) {
        return CategoryModel.models(data);
      }
    },
    requestCategories: function requestCategories() {
      return this.get('type/sponsorCategory');
    }
  });
  return CategoryModel;
});

